import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLoader } from '../../../helpers/useLoader';
import { useAttachmentsService } from '../attachments.service';
import { IAttachmentUploadService } from '../attachmentUploadService';
import { AttachmentUpload } from '../components/AttachmentsUpload';

export const AttachmentUploadContainer = observer((): ReactElement => {
  const uploadService = useInjection(IAttachmentUploadService.$);
  const attachmentsService = useAttachmentsService();

  const { attachmentId } = useParams<{ attachmentId: string }>();
  const { withLoaderAsync } = useLoader();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProcessingImages, setIsProcessingImages] = useState(false);

  const handleFileDropped = async (files: File[]): Promise<void> => {
    setIsProcessingImages(true);
    await uploadService.prepareFilesAsync(files, attachmentId);
    setIsProcessingImages(false);
  };

  const onFileUpload = (): void => {
    const currentAttachmentId = attachmentId;
    const callback = async (): Promise<void> => {
      await withLoaderAsync(async () => {
        if (attachmentId === currentAttachmentId) {
          await attachmentsService.getAttachmentsAsync(attachmentId);
        }
      }, 'attachment-list-loader');
    };
    uploadService.startUpload(callback);
    toggleModal();
  };

  const toggleModal = (): void => {
    setIsModalOpen((prev) => !prev);
    uploadService.data.preparedFiles.replace([]);
  };

  return (
    <AttachmentUpload
      isModalOpen={isModalOpen}
      isProcessingImages={isProcessingImages}
      preparedFiles={uploadService.data.preparedFiles}
      willExceedLimit={uploadService.data.willExceedsLimit}
      toggleModal={toggleModal}
      onFileUpload={onFileUpload}
      handleFileDropped={handleFileDropped}
    />
  );
});
